export function extractNamedParams(text = '') {
  const re = /{{\s*([a-zA-Z0-9_]+)\s*}}/g;
  const params = [];
  let match;
  while ((match = re.exec(text))) params.push(match[1]);
  return params;
}

export function buildTemplateRequest({ wabaId = '', name, category = 'UTILITY', language = 'en', parameter_format = '', headerType, headerText, bodyText, paramExamples = {}, headerHandle = null, mediaType = 'image', isAuthTemplate = false, messageSendTtlSeconds = 600, addSecurityRecommendation = false, codeExpirationMinutes = 10, otpType = 'copy_code', otpButtonText = 'Copy Code', libraryTemplateName = null, libraryTemplateButtonInputs = null }) {
  const lang = Array.isArray(language) ? (language.length ? language[0] : 'en') : language;

  // Library template: Meta already has body/header/footer/buttons configured.
  // Do NOT send components — only name, category, language, and library reference.
  if (libraryTemplateName) {
    const libraryPayload = {
      wabaId,
      name,
      category,
      language: lang,
      library_template_name: libraryTemplateName,
    };

    // Only include button inputs if the library template has configurable buttons
    if (libraryTemplateButtonInputs && libraryTemplateButtonInputs.length > 0) {
      libraryPayload.library_template_button_inputs = libraryTemplateButtonInputs;
    }

    return {
      operation: 'CREATE_TEMPLATE',
      payload: libraryPayload,
    };
  }

  if (isAuthTemplate) {
    const components = [
      {
        type: 'BODY'
      }
    ];

    if (addSecurityRecommendation) {
      components[0].add_security_recommendation = true;
    }

    components.push({
      type: 'FOOTER',
      code_expiration_minutes: codeExpirationMinutes
    });

    components.push({
      type: 'BUTTONS',
      buttons: [
        {
          type: 'otp',
          otp_type: otpType,
          ...(otpButtonText && otpButtonText.trim() ? { text: otpButtonText } : {})
        }
      ]
    });

    return {
      operation: 'CREATE_TEMPLATE',
      payload: {
        wabaId,
        name,
        language: lang,
        category,
        message_send_ttl_seconds: messageSendTtlSeconds,
        components
      }
    };
  }

  const components = [];
  const headerParamNames = headerType === 'text' && headerText ? extractNamedParams(headerText) : [];
  const bodyParamNames = bodyText ? extractNamedParams(bodyText) : [];

  const paramFormat = parameter_format && String(parameter_format).trim() ? String(parameter_format).toUpperCase() : 'NAMED';

  if (headerType === 'text' && headerText) {
    const headerExample = {};
    if (paramFormat === 'NAMED' && headerParamNames.length) {
      headerExample.header_text_named_params = headerParamNames.map(p => ({ param_name: p, example: (paramExamples && paramExamples[p] && String(paramExamples[p]).trim()) ? paramExamples[p] : p }));
    } else if (headerParamNames.length) {
      headerExample.header_text = headerParamNames.map(p => (paramExamples && paramExamples[p] && String(paramExamples[p]).trim()) ? paramExamples[p] : p);
    } else {
      headerExample.header_text = headerText;
    }

    components.push({ type: 'HEADER', format: 'TEXT', text: headerText, example: headerExample });
  }

  else if ((headerType === 'image' || headerType === 'video' || headerType === 'document' || headerType === 'audio') && headerHandle) {
    const format = headerType ? headerType.toUpperCase() : 'IMAGE';

    components.push({
      type: 'HEADER',
      format: format,
      example: {
        header_handle: [headerHandle]
      }
    });
  }

  const bodyComponent = { type: 'BODY', text: bodyText };
  if (bodyParamNames.length) {
    if (paramFormat === 'NAMED') {
      bodyComponent.example = { body_text_named_params: bodyParamNames.map(p => ({ param_name: p, example: (paramExamples && paramExamples[p] && String(paramExamples[p]).trim()) ? paramExamples[p] : p })) };
    } else {
      // Positional parameters must be in numerical order (1, 2, 3...)
      const sortedParams = [...new Set(bodyParamNames)].sort((a, b) => parseInt(a) - parseInt(b));
      bodyComponent.example = { body_text: [ sortedParams.map(p => (paramExamples && paramExamples[p] && String(paramExamples[p]).trim()) ? paramExamples[p] : p) ] };
    }
  }
  components.push(bodyComponent);

  if (Array.isArray(arguments[0].buttons) && arguments[0].buttons.length) {
    components.push({ type: 'BUTTONS', buttons: arguments[0].buttons });
  }

  return {
    operation: 'CREATE_TEMPLATE',
    payload: {
      wabaId,
      name,
      category,
      language: lang,
      parameter_format: paramFormat,
      ...(libraryTemplateName ? { 
        library_template_name: libraryTemplateName,
        library_template_language: lang // Same language as chosen
      } : {}),
      components
    }
  };
}
